<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M14.89 8.44L4 20.5A1.5 1.5 0 005.13 23h21.74A1.5 1.5 0 0028 20.5L17.11 8.44a1.49 1.49 0 00-2.22 0zm.61 7.74L7.14 20l8.36-9.26zm.5.87L24.62 21H7.38zm.5-.87v-5.43L24.86 20z"/></svg>